import AppLabeltypesIndex from "./labelType.vue";
import AppLabeltypesList from "./list/list.vue";
import AppLabeltypesItem from "./item/item.vue";

const routes = [
  {
    path: "/labelType",
    component: AppLabeltypesIndex,
    meta: {
      auth: {
        roles: "labelType.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "labelType.index",
        component: AppLabeltypesList,
        meta: {
          auth: {
            roles: "labelType.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "labelType.create",
        component: AppLabeltypesItem,
        meta: {
          auth: {
            roles: "labelType.create",
            redirect: { name: "labelType.index" }
          }
        }
      },
      {
        path: ":id",
        name: "labelType.edit",
        component: AppLabeltypesItem,
        meta: {
          auth: {
            roles: "labelType.update",
            redirect: { name: "labelType.index" }
          }
        }
      }
    ]
  }
];

export default routes;
